import { render } from "./CouponTemplateReferencesModal.vue?vue&type=template&id=6735ffe4&scoped=true"
import script from "./CouponTemplateReferencesModal.vue?vue&type=script&lang=js"
export * from "./CouponTemplateReferencesModal.vue?vue&type=script&lang=js"

import "./CouponTemplateReferencesModal.vue?vue&type=style&index=0&id=6735ffe4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6735ffe4"]])

export default __exports__